import React, {SVGProps} from 'react';
import {ReactComponent} from '../../assets/svg/map-mobile-icon.svg';

export default (props: SVGProps<any>): JSX.Element => <ReactComponent {...props} />;
